import { Controller } from '@hotwired/stimulus'

// A short-lived confirmation next to whatever was copied — the text sits
// inline in one line, so there is nothing to position dynamically.
export default class extends Controller {
  static targets = ['confirmation']
  static values = { text: String }

  async copy () {
    await navigator.clipboard.writeText(this.textValue)

    this.confirmationTarget.classList.remove('hidden')
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => this.confirmationTarget.classList.add('hidden'), 2000)
  }
}
